<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Card Info'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>

  <tidy-wrapper>


    @if (loaded) {
      <form [formGroup]="form">
        <tidy-card>
          <tidy-row class="field-top-padding field-bottom-padding">
            <tidy-input
              [label]="'Card Name'"
              formControlName="name"
              [form]="form.controls.name"
              [icon]="'assets/svg/list.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter the name of the card'" />
          </tidy-row>
        </tidy-card>
        <tidy-row class="extra-bottom-padding">
          <photo-caption
            [photoUrls]="photoNoteUrls"
            (deletePhoto)="confirmDelete($event)"
            [type]="'closing'"
            />
        </tidy-row>
        <tidy-button
          [text]="'Save Changes'"
          [action]="boundUpdateRoom"
          class="primary" />
      </form>
    }

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
